import CONSTANT from 'modules/constant'
import type { ConfigItemProps, PaginationProps, ResultProps } from 'modules/types'
import { API, headers } from './api'

const ConfigItemApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getConfigItemList: builder.mutation<PaginationProps<ConfigItemProps>, FormData>({
      query: (body) => ({
        url: CONSTANT.URL_CONFIG_ITEM_LIST,
        method: 'POST',
        headers: headers({ useContentType: false }),
        body: body,
        formData: true
      })
    }),
    getConfigItems: builder.mutation<PaginationProps<ConfigItemProps>, FormData>({
      query: (body) => ({
        url: CONSTANT.URL_CONFIG_ITEM_LIST,
        method: 'POST',
        headers: headers({ useContentType: false }),
        body: body,
        formData: true
      })
    }),
    getConfigItemDetail: builder.query<ConfigItemProps, number | string>({
      query: (id) => ({
        url: CONSTANT.URL_CONFIG_ITEM_DETAIL.replace('{id}', id.toString()),
        method: 'GET',
        headers: headers()
      })
    }),
    updateConfigItem: builder.mutation<
      ResultProps,
      { id: number; value: string | null; description: string }
    >({
      query: (body) => ({
        url: CONSTANT.URL_CONFIG_ITEM_UPDATE,
        method: 'POST',
        headers: headers(),
        body: body
      })
    })
  })
})

export const {
  useGetConfigItemListMutation,
  useGetConfigItemDetailQuery,
  useUpdateConfigItemMutation,
  useGetConfigItemsMutation
} = ConfigItemApi
